import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './Assets/Css/bootstrap.css';
import store from './Redux/index';
import { Provider } from 'react-redux';
import './i18n';
import {WebSocketProvider} from "./context/WebSocketContext";

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
    <Provider store={store}>
        <WebSocketProvider>
            <App />
        </WebSocketProvider>
    </Provider>
);
